import React from 'react';
import { Card, Typography, Button } from 'antd';
import { CheckCircleOutlined ,ArrowLeftOutlined} from '@ant-design/icons';
import CustomLayout from '../../layouts/Customlayout';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const { Title, Paragraph } = Typography;

export default function SallaIntegration() {

      
    const navigate=useNavigate()
    
    const { t } = useTranslation();
    const integrationTranslations = t("integration")


  return (
    <CustomLayout>
                    <div className="p-16  mx-auto bg-gradient-to-r from-blue-50 to-white shadow-xl rounded-xl">

    <Button
        icon={<ArrowLeftOutlined />}
        className="mb-6 bg-gray-200 hover:bg-gray-300 border-none px-4 py-2 rounded-lg"
        onClick={() => navigate('/user/integration')}
      >
          {integrationTranslations.backToIntegrations}
      </Button>
      <div style={{ display: 'flex', justifyContent: 'center', padding: '4rem 1rem' }}>

        <Card
          style={{ maxWidth: 500, width: '100%', textAlign: 'center' }}
          bordered={false}
          bodyStyle={{ padding: '2rem' }}
        >
          <CheckCircleOutlined style={{ fontSize: 64, color: '#52c41a' }} />
          <Title level={2} style={{ marginTop: '1rem' }}>
          {integrationTranslations.sallaTab?.connected}
          </Title>
          <Paragraph>
          {integrationTranslations.sallaTab?.description}

          </Paragraph>
          <Button
            type="primary"
            size="large"
            onClick={() => window.location.assign('/user/chatbot')}
          >
            {integrationTranslations.sallaTab?.dashboard_button}
          </Button>
        </Card>
      </div>
      </div>

    </CustomLayout>
  );
}
